module.exports = __webpack_public_path__ + "static/media/BSCX-BNB.2bfc71d2.svg";